import Timeline from '@/components/Timeline'
import LogoTravelshift from '@/components/LogoTravelshift'
import config from '@/config'

export default
{
    components:
    {
        Timeline,
        LogoTravelshift
    },

    data()
    {
        return {
            list: []
        }
    },

    watch:
    {
        $route()
        {
            this.$store.isMenuOpen = false
        },

        '$store.isMenuOpen'(isMenuOpen)
        {
            if (isMenuOpen)
            {
                if (this.$refs.links.scrollTo) {
                    this.$refs.links.scrollTo(0, 0)
                } else {
                    // IE11 fix
                    this.$refs.links.scrollTop = 0
                }
            }
        }
    },

    computed:
    {
        current()
        {
            return this.list
                .find(route => route.name === this.$route.name)
        },

        logoColor()
        {
            return this.$store.background === 'black' ? 'white' : config.colors.blue
        }
    },

    created()
    {
        this.list = this.$store.routes
            .filter(route => route.meta && route.meta.isSlide)
            .map(route => JSON.parse(JSON.stringify(route)))
            .map((route, i) =>
            {
                const id = i + 1
                return Object.assign({
                    id,
                    num: id + '. '
                }, route)
            })
    },

    methods:
    {
        toggle()
        {
            this.$store.isMenuOpen = !this.$store.isMenuOpen
        },

        digitToString(num)
        {
            return (num < 10 ? '0' : '') + num
        }
    }
}
